<div #visualObjectContainer>
  <div class="panel visual-object-margin code-panel" [class.border-style]="!showTitle"

       [style.max-height]="!showTitle && height"
       [style.max-width]="!showTitle && width"
       [style.width.%]="!showTitle && '100'">

    <gridview classes="px-0">
      <gridview-header *ngIf="showTitle" classes="panel-header mx-0">
        <header-columntemplate size="auto" classes="header-image">
          <co-image width="24" height="24" type="svg" key="code" [imageSet]="imageSet"></co-image>
        </header-columntemplate>
        <header-columntemplate classes="header-title">
          {{panel.title}}
        </header-columntemplate>
      </gridview-header>
      <div [class.px-3]="isRender" [class.py-2]="isRender" [style.max-height]="showTitle && height" [style.max-width]="showTitle && width" [style.width.%]="'100'">

        <panel-codes-builder [valuesModel]="valuesModel"> </panel-codes-builder>

      </div>
    </gridview>
  </div>
</div>